export default __webpack_public_path__ + "static/media/close.76693935.svg";